<template>
  <EmdPanel>
    <EmdPanelSection :title="$t('recipients.create.identification')">
      <EmdFormGroup
        :label="$t('recipients.create.type')"
        :required="canEdit"
      >
        <div
          v-if="canEdit"
          class="eu-mt_2"
        >
          <EmdRadio
            :label="$t('recipients.create.type_individual')"
            id="recipient_type_individual"
            name="recipient_type"
            value="individual"
            v-model="recipient.type"
            @change="handleChangeType"
            class="eu-mr_4 eu-mb_2"
          />

          <EmdRadio
            :label="$t('recipients.create.type_company')"
            id="recipient_type_company"
            name="recipient_type"
            :value="canCreateRecipient ? 'company' : 'corporation'"
            v-model="recipient.type"
            @change="handleChangeType"
            class="eu-mb_2"
          />
        </div>
        <span v-else>{{ recipientType }}</span>
      </EmdFormGroup>
    </EmdPanelSection>
  </EmdPanel>
</template>

<script>
import {
  EmdPanel,
  EmdPanelSection,
  EmdFormGroup,
  EmdRadio
} from 'emerald-vue/src/components'

import { getState, feedbacks } from '@/utils/form.utils'
import { mapGetters } from 'vuex'

export default {
  name: 'Identification',
  components: {
    EmdPanel,
    EmdPanelSection,
    EmdFormGroup,
    EmdRadio
  },
  data: () => ({
    getState,
    feedbacks
  }),
  props: {
    recipient: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: true
    },
    default_bank_account: {
      type: Object,
      required: true
    },
    vuelidate: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['canCreateRecipient']),
    recipientType () {
      return this.recipient.type === 'individual'
        ? this.$t('recipients.create.type_individual')
        : this.$t('recipients.create.type_company')
    }
  },
  methods: {
    handleChangeDocument () {
      this.vuelidate.recipient.document.$touch()
    },

    handleChangeType () {
      this.default_bank_account.holder_type = this.recipient.type
    }
  }
}
</script>
